import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaManagementRotaFilterParams } from "@/api_framework/api_modals/Rota";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setRotaFilterData } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});
export const useRotaShiftFilterAPI = () => {
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (filter_params: IRotaManagementRotaFilterParams) => {
      dispatch(
        setLoading({
          key: "isClinicWiseRotaListInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        if (!accessToken) {
          throw new Error("Access token not available");
        }

        await axios
          .post(ROTA_APIS?.ROTA_SHIFT_FILTER?.baseURL ?? "", filter_params, {
            params: {},
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            if (res.data.status === true) {
              dispatch(setRotaFilterData({ data: res.data.data }));
              dispatch(
                setLoading({
                  key: "isClinicWiseRotaListInProgress",
                  status: false,
                }),
              );
            } else {
              dispatch(
                setLoading({
                  key: "isClinicWiseRotaListInProgress",
                  status: false,
                }),
              );
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setRotaFilterData({ data: [] }));
            dispatch(
              setLoading({
                key: "isClinicWiseRotaListInProgress",
                status: false,
              }),
            );
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        dispatch(setRotaFilterData({ data: [] }));
        dispatch(
          setLoading({
            key: "isClinicWiseRotaListInProgress",
            status: false,
          }),
        );
        if (error instanceof AxiosError) {
          if (error.response?.status === 400) {
            dispatch(
              setLoading({
                key: "isClinicWiseRotaListInProgress",
                status: false,
              }),
            );
          }
        }
        if (error.response.status === 500) {
          toast.error("Server error 500");
          dispatch(
            setLoading({
              key: "isClinicWiseRotaListInProgress",
              status: false,
            }),
          );
        }
      }
    },
    [dispatch, configuration],
  );

  return execute;
};
